import { Module } from '../../types'

const isPeopleAlsoViewedModule = (node: unknown): boolean => {
  if (node === null || typeof node !== 'object') {
    return false
  }
  const module = node as Record<string, unknown>
  return (
    module.__typename === 'ModulePeopleAlsoViewedVariant' ||
    module.__typename === 'ModulePeopleAlsoViewed'
  )
}

const process = (node: unknown): unknown => {
  if (isPeopleAlsoViewedModule(node)) {
    return { __typename: 'ModuleMoreLikeThis' as const }
  }

  if (Array.isArray(node)) {
    return node.map(process)
  }

  if (node !== null && typeof node === 'object') {
    return Object.fromEntries(
      Object.entries(node).map(([key, childNode]) => [key, process(childNode)]),
    )
  }
  return node
}

export const replacePeopleAlsoViewedWithMoreLikeThis = (
  modules: Module[],
): Module[] => process(modules) as Module[]
